// src/types.ts
var WorkbookLoadedEventName = "workbook:loaded";
var WorkbookErrorEventName = "workbook:error";
var WorkbookVariableEventOnChangeName = "workbook:variables:onchange";
var WorkbookTableCellSelectEventName = "workbook:table:oncellselect";
var WorkbookPublishedEventName = "workbook:published";
var WorkbookFullScreenEventName = "workbook:fullscreen:onchange";
var WorkbookPageHeightEventName = "workbook:pageheight:onchange";
var WorkbookSelectedNodeEventName = "workbook:selectednodeid:onchange";
var WorkbookPivotTableCellSelectEventName = "workbook:pivottable:oncellselect";
var WorkbookChartValueSelectEventName = "workbook:chart:onvalueselect";
var WorkbookCurrentVariablesEventName = "workbook:variables:current";
var WorkbookBookmarkOnCreateEventName = "workbook:bookmark:oncreate";
var WorkbookDataLoadedEventName = "workbook:dataloaded";
var WorkbookChartErrorEventName = "workbook:chart:error";
var WorkbookExploreKeyOnChangeEventName = "workbook:exploreKey:onchange";
var WorkbookBookmarkOnChangeEventName = "workbook:bookmark:onchange";
var UrlOnChangeEventName = "url:onchange";
var WorkbookIdOnChangeEventName = "workbook:id:onchange";
var WorkbookBookmarkCreateEventName = "workbook:bookmark:create";
var WorkbookBookmarkUpdateEventName = "workbook:bookmark:update";
var WorkbookFullscreenUpdateEventName = "workbook:fullscreen:update";
var WorkbookSelectedNodeIdUpdateEventName = "workbook:selectednodeid:update";
var WorkbookVariablesListEventName = "workbook:variables:list";
var WorkbookVariablesUpdateEventName = "workbook:variables:update";
var WorkbookVariablesCurrentEventName = "workbook:variables:current";
var WorkbookSharingLinkUpdateEventName = "workbook:sharinglink:update";
var ActionOutboundEventName = "action:outbound";

// src/wrapper.ts
var checkEventOrigin = (url) => {
  const hostname = new URL(url).hostname;
  const hostnameSplit = hostname.split(".");
  const domain = hostnameSplit.slice(-2).join(".");
  return ["sigmacomputing.io", "sigmacomputing.com"].includes(domain);
};
var workbookLoadedListener = (event, iframe, onLoaded) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookLoadedEventName) {
      onLoaded(event.data);
    }
  }
};
var workbookErrorListener = (event, iframe, onError) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookErrorEventName) {
      onError(event.data);
    }
  }
};
var workbookVariableChangeListener = (event, iframe, onVariable) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookVariableEventOnChangeName) {
      onVariable(event.data);
    }
  }
};
var workbookVariableCurrentListener = (event, iframe, onVariable) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookVariablesCurrentEventName) {
      onVariable(event.data);
    }
  }
};
var workbookLinkSharingUpdateListener = (event, iframe, onVariable) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookSharingLinkUpdateEventName) {
      onVariable(event.data);
    }
  }
};
var workbookTableCellSelectListener = (event, iframe, onTableCellSelect) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookTableCellSelectEventName) {
      onTableCellSelect(event.data);
    }
  }
};
var workbookPublishedListener = (event, iframe, onPublished) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookPublishedEventName) {
      onPublished(event.data);
    }
  }
};
var workbookFullScreenListener = (event, iframe, onFullScreen) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookFullScreenEventName) {
      onFullScreen(event.data);
    }
  }
};
var workbookPageHeightListener = (event, iframe, onPageHeight) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookPageHeightEventName) {
      onPageHeight(event.data);
    }
  }
};
var workbookSelectedNodeListener = (event, iframe, onPageSelectedNode) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookSelectedNodeEventName) {
      onPageSelectedNode(event.data);
    }
  }
};
var workbookPivotTableCellSelectListener = (event, iframe, onPivotTableCellSelect) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookPivotTableCellSelectEventName) {
      onPivotTableCellSelect(event.data);
    }
  }
};
var workbookChartValueSelectListener = (event, iframe, onChartValueSelect) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookChartValueSelectEventName) {
      onChartValueSelect(event.data);
    }
  }
};
var workbookCurrentVariablesListener = (event, iframe, onCurrentVariables) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookCurrentVariablesEventName) {
      onCurrentVariables(event.data);
    }
  }
};
var workbookBookmarkCreateListener = (event, iframe, onBookmarkCreate) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookBookmarkOnCreateEventName) {
      onBookmarkCreate(event.data);
    }
  }
};
var workbookDataLoadedListener = (event, iframe, onWorkbookDataLoaded) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookDataLoadedEventName) {
      onWorkbookDataLoaded(event.data);
    }
  }
};
var workbookChartErrorListener = (event, iframe, onChartError) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookChartErrorEventName) {
      onChartError(event.data);
    }
  }
};
var workbookExploreKeyOnChangeListener = (event, iframe, onExploreKeyOnChange) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookExploreKeyOnChangeEventName) {
      onExploreKeyOnChange(event.data);
    }
  }
};
var workbookBookmarkOnChangeListener = (event, iframe, onBookmarkChange) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookBookmarkOnChangeEventName) {
      onBookmarkChange(event.data);
    }
  }
};
var urlOnChangeListener = (event, iframe, onUrlChange) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === UrlOnChangeEventName) {
      onUrlChange(event.data);
    }
  }
};
var workbookIdOnChangeListener = (event, iframe, onWorkbookIdChange) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === WorkbookIdOnChangeEventName) {
      onWorkbookIdChange(event.data);
    }
  }
};
var actionOutboundListener = (event, iframe, onActionOutbound) => {
  if (event.source === iframe.contentWindow && checkEventOrigin(event.origin)) {
    if (event.data.type === ActionOutboundEventName) {
      onActionOutbound(event.data);
    }
  }
};

// src/mutations.ts
var SIGMA_COMPUTING_URL = "https://app.sigmacomputing.com";
var sendIframeMessage = (iframe, message) => {
  if (!iframe.contentWindow) {
    throw new Error("iframe contentWindow is not available");
  }
  iframe.contentWindow.postMessage(message, SIGMA_COMPUTING_URL);
};
var DO_NOT_USE_IN_PRODUCTION_overrideMutationUrl = (url) => {
  SIGMA_COMPUTING_URL = url;
};
var workbookBookmarkCreate = (iframe, bookmark) => {
  sendIframeMessage(iframe, {
    type: WorkbookBookmarkCreateEventName,
    ...bookmark
  });
};
var workbookBookmarkUpdate = (iframe) => {
  sendIframeMessage(iframe, {
    type: WorkbookBookmarkUpdateEventName
  });
};
var workbookFullscreenUpdate = (iframe, nodeId) => {
  sendIframeMessage(iframe, {
    type: WorkbookFullscreenUpdateEventName,
    nodeId
  });
};
var workbookSelectedNodeIdUpdate = (iframe, nodeId, nodeType) => {
  sendIframeMessage(iframe, {
    type: WorkbookSelectedNodeIdUpdateEventName,
    nodeId,
    nodeType
  });
};
var workbookVariablesList = (iframe) => {
  sendIframeMessage(iframe, {
    type: WorkbookVariablesListEventName
  });
};
var workbookVariablesUpdate = (iframe, variables) => {
  sendIframeMessage(iframe, {
    type: WorkbookVariablesUpdateEventName,
    variables
  });
};
var workbookSharingLinkUpdate = (iframe, sharingLink, sharingExplorationLink) => {
  sendIframeMessage(iframe, {
    type: WorkbookSharingLinkUpdateEventName,
    sharingLink,
    sharingExplorationLink
  });
};
export {
  DO_NOT_USE_IN_PRODUCTION_overrideMutationUrl,
  actionOutboundListener,
  urlOnChangeListener,
  workbookBookmarkCreate,
  workbookBookmarkCreateListener,
  workbookBookmarkOnChangeListener,
  workbookBookmarkUpdate,
  workbookChartErrorListener,
  workbookChartValueSelectListener,
  workbookCurrentVariablesListener,
  workbookDataLoadedListener,
  workbookErrorListener,
  workbookExploreKeyOnChangeListener,
  workbookFullScreenListener,
  workbookFullscreenUpdate,
  workbookIdOnChangeListener,
  workbookLinkSharingUpdateListener,
  workbookLoadedListener,
  workbookPageHeightListener,
  workbookPivotTableCellSelectListener,
  workbookPublishedListener,
  workbookSelectedNodeIdUpdate,
  workbookSelectedNodeListener,
  workbookSharingLinkUpdate,
  workbookTableCellSelectListener,
  workbookVariableChangeListener,
  workbookVariableCurrentListener,
  workbookVariablesList,
  workbookVariablesUpdate
};
